import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { useTranslation } from "react-i18next";

const Services = (props) => {
  const { t } = useTranslation("clientSite");
  const services = props.site.services || [];

  return (
    <div>
      <div className="sectionIntro">
        {/* <span className="sectionIntro__eyebrow">Services</span> */}
        <h2 className="sectionIntro__title">{props.site.servicePageTitle}</h2>
        <p className="sectionIntro__text">{props.site.serviceDescription}</p>
      </div>

      <Swiper
        className="siteCarousel"
        spaceBetween={16}
        slidesPerView={1.15}
        pagination={{ clickable: true }}
        centerInsufficientSlides={true}
        modules={[Pagination]}
        breakpoints={{
          480: { slidesPerView: 1.35, spaceBetween: 16 },
          640: { slidesPerView: 2.1, spaceBetween: 18 },
          900: { slidesPerView: 3, spaceBetween: 20 },
          1200: { slidesPerView: 4, spaceBetween: 22 },
        }}
      >
        {services.map((val, i) => (
          <SwiperSlide key={i}>
            <article className="serviceCard">
              <div className="serviceCard__icon">✦</div>
              <h3 className="serviceCard__title">{val.name}</h3>
              <p className="serviceCard__text">{val.description}</p>
            </article>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="sectionCta">
        <a target="_blank" rel="noreferrer" className="site-bookBtn" href={`make-a-booking?id=${props.site.barberShopId}`}>
          {t("bookNow")}
        </a>
      </div>
    </div>
  );
};

export default Services;
